// Font Awesome Pro 6.4.0 solid icons, copied from the @rq-ratings/pro-solid-svg-icons
// package so the app no longer needs a GitHub Packages token to install.
// Our Pro licence has expired; it still covers 6.4.0 but not newer versions.
// Do not add icons here. See LICENSE.txt in this folder.

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faAdd: IconDefinition = {
  prefix: 'fas',
  iconName: 'plus',
  icon: [
    448,
    512,
    ['add'],
    '2b',
    'M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faArrowAltCircleDown: IconDefinition = {
  prefix: 'fas',
  iconName: 'circle-down',
  icon: [
    512,
    512,
    ['arrow-alt-circle-down'],
    'f358',
    'M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6L269.8 394.5c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L135.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3c0-12.3 10-22.3 22.3-22.3l57.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 57.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faArrowDown: IconDefinition = {
  prefix: 'fas',
  iconName: 'arrow-down',
  icon: [
    384,
    512,
    [],
    'f063',
    'M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faArrowLeft: IconDefinition = {
  prefix: 'fas',
  iconName: 'arrow-left',
  icon: [
    448,
    512,
    [],
    'f060',
    'M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faArrowRight: IconDefinition = {
  prefix: 'fas',
  iconName: 'arrow-right',
  icon: [
    448,
    512,
    [],
    'f061',
    'M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faBuilding: IconDefinition = {
  prefix: 'fas',
  iconName: 'building',
  icon: [
    384,
    512,
    [],
    'f1ad',
    'M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faCaretDown: IconDefinition = {
  prefix: 'fas',
  iconName: 'caret-down',
  icon: [
    320,
    512,
    [],
    'f0d7',
    'M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faCaretUp: IconDefinition = {
  prefix: 'fas',
  iconName: 'caret-up',
  icon: [
    320,
    512,
    [],
    'f0d8',
    'M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faChain: IconDefinition = {
  prefix: 'fas',
  iconName: 'link',
  icon: [
    640,
    512,
    ['chain'],
    'f0c1',
    'M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faCheck: IconDefinition = {
  prefix: 'fas',
  iconName: 'check',
  icon: [
    448,
    512,
    [],
    'f00c',
    'M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faCheckCircle: IconDefinition = {
  prefix: 'fas',
  iconName: 'circle-check',
  icon: [
    512,
    512,
    ['check-circle'],
    'f058',
    'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faChevronDown: IconDefinition = {
  prefix: 'fas',
  iconName: 'chevron-down',
  icon: [
    512,
    512,
    [],
    'f078',
    'M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faChevronUp: IconDefinition = {
  prefix: 'fas',
  iconName: 'chevron-up',
  icon: [
    512,
    512,
    [],
    'f077',
    'M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faCircle: IconDefinition = {
  prefix: 'fas',
  iconName: 'circle',
  icon: [
    512,
    512,
    [],
    'f111',
    'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faCircleCheck: IconDefinition = {
  prefix: 'fas',
  iconName: 'circle-check',
  icon: [
    512,
    512,
    ['check-circle'],
    'f058',
    'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faCircleInfo: IconDefinition = {
  prefix: 'fas',
  iconName: 'circle-info',
  icon: [
    512,
    512,
    ['info-circle'],
    'f05a',
    'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faCircleQuestion: IconDefinition = {
  prefix: 'fas',
  iconName: 'circle-question',
  icon: [
    512,
    512,
    ['question-circle'],
    'f059',
    'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faCircleX: IconDefinition = {
  prefix: 'fas',
  iconName: 'circle-x',
  icon: [
    512,
    512,
    [],
    'e12e',
    'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM186.3 136.5L256 218.8l69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L287.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L256 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8L224.6 256l-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faEllipsisV: IconDefinition = {
  prefix: 'fas',
  iconName: 'ellipsis-vertical',
  icon: [
    128,
    512,
    ['ellipsis-v'],
    'f142',
    'M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faEnvelope: IconDefinition = {
  prefix: 'fas',
  iconName: 'envelope',
  icon: [
    512,
    512,
    [],
    'f0e0',
    'M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faExclamationTriangle: IconDefinition = {
  prefix: 'fas',
  iconName: 'triangle-exclamation',
  icon: [
    512,
    512,
    ['exclamation-triangle', 'warning'],
    'f071',
    'M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faEyeSlash: IconDefinition = {
  prefix: 'fas',
  iconName: 'eye-slash',
  icon: [
    640,
    512,
    [],
    'f070',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faFileLines: IconDefinition = {
  prefix: 'fas',
  iconName: 'file-lines',
  icon: [
    384,
    512,
    ['file-alt', 'file-text'],
    'f15c',
    'M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faFlagCheckered: IconDefinition = {
  prefix: 'fas',
  iconName: 'flag-checkered',
  icon: [
    448,
    512,
    [],
    'f11e',
    'M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1V345.8c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V400 334 64 32C0 14.3 14.3 0 32 0zM64 187.1l64-13.9v65.5L64 252.6V318l48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3V238.7l38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1l0-64c13.6 .4 27.2 2.6 40.4 6.4l23.6 6.9v66.7l-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8v71.4c21.8 1.9 43.3 6.7 64 14.4V244.2l22.7 6.7c13.5 4 27.3 6.4 41.3 7.4V194c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12v-62c-13-3.8-25.8-8.8-38.2-15c-8.2-4.1-16.9-7-25.8-8.8v72.4c-13-.4-26 .8-38.7 3.6L128 173.2V98L64 114v73.1zM320 335.7c16.8 1.5 33.9-.7 50-6.8l14-5.2V251.9l-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5v77.4zm64-149.4V115.4c-20.9 6.1-42.4 9.1-64 9.1V194c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faLinkSlash: IconDefinition = {
  prefix: 'fas',
  iconName: 'link-slash',
  icon: [
    640,
    512,
    ['chain-broken', 'chain-slash', 'unlink'],
    'f127',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5L239 162zM406.6 416.4L220.9 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3zm-290-228.5L60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faLock: IconDefinition = {
  prefix: 'fas',
  iconName: 'lock',
  icon: [
    448,
    512,
    [],
    'f023',
    'M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faLockKeyhole: IconDefinition = {
  prefix: 'fas',
  iconName: 'lock-keyhole',
  icon: [
    448,
    512,
    ['lock-alt'],
    'f30d',
    'M224 64c44.2 0 80 35.8 80 80v48H144V144c0-44.2 35.8-80 80-80zM80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H368V144C368 64.5 303.5 0 224 0S80 64.5 80 144zM256 320v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32s32 14.3 32 32z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faLockOpen: IconDefinition = {
  prefix: 'fas',
  iconName: 'lock-open',
  icon: [
    576,
    512,
    [],
    'f3c1',
    'M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32V144C576 64.5 511.5 0 432 0S288 64.5 288 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V144z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faMinus: IconDefinition = {
  prefix: 'fas',
  iconName: 'minus',
  icon: [
    448,
    512,
    ['subtract'],
    'f068',
    'M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faPencil: IconDefinition = {
  prefix: 'fas',
  iconName: 'pencil',
  icon: [
    512,
    512,
    ['pencil-alt'],
    'f303',
    'M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faPlus: IconDefinition = {
  prefix: 'fas',
  iconName: 'plus',
  icon: [
    448,
    512,
    ['add'],
    '2b',
    'M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faQuestionCircle: IconDefinition = {
  prefix: 'fas',
  iconName: 'circle-question',
  icon: [
    512,
    512,
    ['question-circle'],
    'f059',
    'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faSackDollar: IconDefinition = {
  prefix: 'fas',
  iconName: 'sack-dollar',
  icon: [
    512,
    512,
    [],
    'f81d',
    'M320 96H192L144.6 24.9C137.5 14.2 145.1 0 157.9 0H354.1c12.8 0 20.4 14.2 13.3 24.9L320 96zM192 128H320c3.8 2.5 8.1 5.3 13 8.4C389.7 172.7 512 250.9 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96C0 250.9 122.3 172.7 179 136.4l0 0 0 0c4.8-3.1 9.2-5.9 13-8.4zm84 88c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V424c0 11 9 20 20 20s20-9 20-20V410.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l0 0-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V216z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faSearch: IconDefinition = {
  prefix: 'fas',
  iconName: 'magnifying-glass',
  icon: [
    512,
    512,
    ['search'],
    'f002',
    'M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faSpinner: IconDefinition = {
  prefix: 'fas',
  iconName: 'spinner',
  icon: [
    512,
    512,
    [],
    'f110',
    'M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faSuitcase: IconDefinition = {
  prefix: 'fas',
  iconName: 'suitcase',
  icon: [
    512,
    512,
    [],
    'f0f2',
    'M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96v32V480H128V128 96zM64 96H96V480H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zM448 480H416V96h32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faTimes: IconDefinition = {
  prefix: 'fas',
  iconName: 'xmark',
  icon: [
    384,
    512,
    ['close', 'multiply', 'remove', 'times'],
    'f00d',
    'M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faTimesCircle: IconDefinition = {
  prefix: 'fas',
  iconName: 'circle-xmark',
  icon: [
    512,
    512,
    ['times-circle', 'xmark-circle'],
    'f057',
    'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faTrash: IconDefinition = {
  prefix: 'fas',
  iconName: 'trash',
  icon: [
    448,
    512,
    [],
    'f1f8',
    'M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faTriangleExclamation: IconDefinition = {
  prefix: 'fas',
  iconName: 'triangle-exclamation',
  icon: [
    512,
    512,
    ['exclamation-triangle', 'warning'],
    'f071',
    'M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faTrianglePersonDigging: IconDefinition = {
  prefix: 'fas',
  iconName: 'triangle-person-digging',
  icon: [
    640,
    512,
    ['construction'],
    'f85d',
    'M354.5 51.8C347.3 39.5 334.2 32 320 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S89.7 480 104 480H536c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368zM216.9 304.7l15.6 9.8 64 40c4.7 2.9 7.5 8.1 7.5 13.6v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V376.9l-40.9-25.5-24.5 55.2c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l32-72 7.5-16.8zm112-45.7l19.7 49.2L402 339l16.3-27.2c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l48 80c3 4.9 3 11.1 .2 16.1s-8.2 8.1-13.9 8.1H384c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l15.2-25.4L232 277.9c-3.8-2.2-6.6-5.9-7.6-10.2s-.2-8.8 2.3-12.5l4.2-6.4c10.3-15.5 27.7-24.8 46.3-24.8c22.7 0 43.2 13.8 51.6 34.9zM288 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faUnlock: IconDefinition = {
  prefix: 'fas',
  iconName: 'unlock',
  icon: [
    448,
    512,
    [],
    'f09c',
    'M144 144c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7c7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H144V144z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faUserCircle: IconDefinition = {
  prefix: 'fas',
  iconName: 'circle-user',
  icon: [
    512,
    512,
    ['user-circle'],
    'f2bd',
    'M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faWarning: IconDefinition = {
  prefix: 'fas',
  iconName: 'triangle-exclamation',
  icon: [
    512,
    512,
    ['exclamation-triangle', 'warning'],
    'f071',
    'M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
}
